import * as FilterCRMSearchSimple from '../crmSearch/FilterCRMSearchSimple';
import * as ObjectTypeIds from 'customer-data-objects/constants/ObjectTypeIds';
import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { OrderedMap } from 'immutable';
import InboundDbListMembershipProperty from './psuedoProperties/InboundDbListMembershipProperty';
import MissingField from 'customer-data-filters-ui/filterQueryFormat/MissingField';
import getIn from 'transmute/getIn';
import invariant from 'react-utils/invariant';
import { And, Or } from '../../filterQueryFormat/logic/FilterLogicGroup';
const getFilter = (condition, getIsUngated) => FilterCRMSearchSimple.convertToCRMSearch(condition, getIsUngated);
const getFilterGroup = (logicGroup, getIsUngated) => ({
  filters: logicGroup.conditions.map(condition => {
    return getFilter(condition, getIsUngated);
  }).toArray()
});
const getFilterGroups = (logicGroup, getIsUngated) => ({
  filterGroups: logicGroup.conditions.map(condition => {
    return getFilterGroup(condition, getIsUngated);
  }).toArray()
});
export function toCRMSearch(logicGroup, getIsUngated) {
  const {
    ObjectTypesToIds
  } = ObjectTypeIds;
  const filter = getFilterGroups(logicGroup, getIsUngated);
  const filterFamily = logicGroup.get('filterFamily');
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const objectTypeId = ObjectTypesToIds[filterFamily] || filterFamily;
  return Object.assign({}, filter, {
    objectTypeId
  });
}
const makeOperator = (condition, index, objectTypeId, getField, getIsUngated, serializerOptions) => {
  const convertEntry = (filterFamily, entry) => {
    const fieldRecord = getField([filterFamily, entry.property]) || getField([entry.property]) || MissingField({
      name: entry.property,
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      type: PropertyTypes[entry.dateTimeFormat] || PropertyTypes.STRING
    });

    // converts old format for associations to new one
    const OldAssociationPropertyFormat = /associations.\d-\d+/;
    if (OldAssociationPropertyFormat.test(entry.property)) {
      const {
        operator,
        property,
        value
      } = entry;
      return convertEntry(filterFamily, {
        operator,
        property: 'associations.labeled',
        propertySuffix: property.split('.').pop(),
        value: `${value}`
      });
    }

    // converts old format for list memberships to new one
    if (entry.property === 'ilsListMemberships.listId') {
      const {
        operator,
        values
      } = entry;
      return convertEntry(filterFamily, {
        operator,
        property: InboundDbListMembershipProperty.name,
        values
      });
    }
    const Operator = FilterCRMSearchSimple.TypeToOperator.get(entry.operator);
    invariant(Operator !== undefined, 'contact search operator `%s` is not defined in OperatorConversion', entry.operator);
    const useSalesViewsSerialization = !!serializerOptions && serializerOptions.useSalesViewsSerialization;
    const converter = useSalesViewsSerialization ? FilterCRMSearchSimple.convertFromSalesViews(getIsUngated).get(entry.operator) : FilterCRMSearchSimple.convertFromCRMSearch().get(entry.operator);
    invariant(typeof converter === 'function', 'no converter defined from `%s` to `%s` operator', entry.operator, Operator.toString());
    return converter(Operator, fieldRecord, entry, getIsUngated);
  };
  const operator = convertEntry(objectTypeId, condition);
  return [`${operator.field.name} ${operator.name} ${index}`, operator];
};
const makeLogicGroup = (filterGroup, objectTypeId, getField, getIsUngated, serializerOptions) => {
  return And.of().set('conditions', OrderedMap(filterGroup.filters.map((condition, index) => makeOperator(condition, index, objectTypeId, getField, getIsUngated, serializerOptions)))).set('filterFamily', objectTypeId);
};
export function fromCRMSearch(fields, json, getIsUngated, defaultObjectTypeId = ObjectTypeIds.CONTACT_TYPE_ID, serializerOptions) {
  const getField = typeof fields === 'function' ? fields : keyPath => getIn(keyPath, fields);
  if (!fields || !json) {
    return Or.of();
  }
  const {
    objectTypeId = defaultObjectTypeId,
    filterGroups
  } = json;
  return Or.ofRoot().set('conditions', OrderedMap(filterGroups.map((group, index) => [index.toString(), makeLogicGroup(group, objectTypeId, getField, getIsUngated, serializerOptions)]))).set('filterFamily', objectTypeId);
}